<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
      >
        <v-chip-group
          multiple
          active-class="primary--text"
        >
          <v-chip
            v-for="(tag, index) in tags"
            :key="tag.name"
            :color="genColor(index, tag.count)"
          >
            {{ tag.name }} ({{ tag.count }})
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import colors from 'vuetify/lib/util/colors'

export default {
  name: 'TagsList',
  methods: {
    ...mapActions(['fetchTags']),
    genColor: function(i, j) {
      let colorsLength = Object.keys(colors).length
      let colorFamily = Object.keys(colors)[i % colorsLength]

      let colorFamilyLength = Object.keys(colors[colorFamily]).length
      let color = Object.keys(colors[colorFamily])[j % colorFamilyLength]

      return colors[colorFamily][color]
    }
  },
  computed: mapGetters(['tags']),
  created() {
    this.fetchTags()
  }
}
</script>